import { useFlags } from "launchdarkly-react-client-sdk";
import { useContext, useMemo } from "react";
import { AuthContext } from "../AuthContext";

const useOnlyVisibleToDevs = (): boolean => {
  const { visibleToDevs } = useFlags();
  const { authState } = useContext(AuthContext);

  return useMemo(
    () => visibleToDevs?.includes(btoa(authState?.username || "")),
    [visibleToDevs, authState]
  );
};

export default useOnlyVisibleToDevs;
